"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchList = void 0;
var react_1 = require("react");
var acorn_react_core_1 = require("@gcdtech/acorn-react-core");
var useFetchList = function (fetchListDelegate, fetchOptions) {
    var _a, _b;
    var _c = react_1.useState({
        range: { offset: 0, limit: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit },
        criteria: __assign({}, fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialCriteria),
        sorts: __spreadArray([], ((_a = fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialSorts) !== null && _a !== void 0 ? _a : [])),
        includeCounts: (_b = fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.includeCounts) !== null && _b !== void 0 ? _b : false,
    }), request = _c[0], setRequest = _c[1];
    // Here we wrap the list delegate to construct the necessary arguments
    // the underlying useFetch delegate will need.
    var fetchDelegate = function (newRequest) {
        if (newRequest) {
            setRequest(newRequest);
        }
        return fetchListDelegate(newRequest !== null && newRequest !== void 0 ? newRequest : request);
    };
    var _d = acorn_react_core_1.useFetch(fetchDelegate, __assign(__assign({}, fetchOptions), { preservePreviousItemDuringFetch: true, initialValue: {
            items: [],
            totalCount: 0,
            range: { offset: 0, limit: 0 },
            // @ts-expect-error - TS complaining "Type '{ phrase: ""; }' is not assignable to type 'Partial<CriteriaType>'"
            // yet CriteriaType must extend {phrase?: string} (see line 67) so I can't see why it's complaining
            criteria: { phrase: '' },
            sorts: [],
            includeCounts: false,
        } })), item = _d.item, items = _d.item, fetched = _d.fetched, fetching = _d.fetching, fetchingSlowly = _d.fetchingSlowly, fetchingSlowlyDebounced = _d.fetchingSlowlyDebounced, reset = _d.reset, fetch = _d.fetch;
    var changePageNumber = function (pageNumber) {
        return changeOffset((pageNumber - 1) * fetchOptions.limit);
    };
    var changeOffset = function (offset) {
        return fetch(__assign(__assign({}, request), { range: __assign(__assign({}, request.range), { offset: offset }) }));
    };
    var offset = item ? item.range.offset : request.range.offset;
    return {
        item: item,
        items: item.items,
        // The 'request' is a reflection of the server presented request if we have one - otherwise it is the outgoing
        // request. This ensures that things like default sorts, applied at the server side, are reflected
        // in the UI. The server response is our source of truth for the UI state, not the request made.
        request: item
            ? { criteria: item.criteria, sorts: item.sorts, range: item.range, includeCounts: item.includeCounts }
            : request,
        fetch: fetch,
        refetch: function () {
            return fetch(request);
        },
        reset: reset,
        fetched: fetched,
        fetching: fetching,
        fetchingSlowly: fetchingSlowly,
        fetchingSlowlyDebounced: fetchingSlowlyDebounced,
        offset: offset,
        pageNumber: (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit) ? Math.round(offset / (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit)) + 1 : 1,
        pageCount: item.totalCount ? Math.ceil(item.totalCount / (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit)) : 1,
        limit: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit,
        pageSize: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.limit,
        changeOffset: changeOffset,
        changePageNumber: changePageNumber,
    };
};
exports.useFetchList = useFetchList;
//# sourceMappingURL=useFetchList.js.map